import { AccountingConnectionType, accountingSystemConfig } from "shared";

import { Modal } from "../../../common/Atoms/Modal";
import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";
import { Divider } from "../../../common/Atoms/Divider";
import { AccountingConnectButton } from "../AccountingConnectButton";

interface AccountingConnectModalProps {
  /** Modal is open while a type is set */
  type: AccountingConnectionType | null;
  reconnect?: boolean;
  onCancel: () => void;
}

export function AccountingConnectModal({ type, reconnect, onCancel }: AccountingConnectModalProps) {
  const displayName = type ? accountingSystemConfig[type].provider.displayName : ``;

  return (
    <Modal
      title={ `` }
      open={ !!type }
      // This is the top X, treat as cancel
      setOpen={ onCancel }
    >
      <div className={ `flex flex-col items-center mt-6` }>
        <Paragraph variant={ `primary` }>
          { reconnect ?
            `Paidnice is unable to connect to this organisation, please reconnect to ${displayName} by clicking the button below. Once reconnected all settings will be restored.` :
            `To get started connect to ${displayName} by clicking the button below. Don't worry, once you connect Paidnice won't change anything in your accounting system until you are ready.` }
        </Paragraph>

        <Divider weight={ `light` } />

        { type && <AccountingConnectButton type={ type } /> }
      </div>
    </Modal>
  );
}
